/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type WithdrawWorkloadIssuerSecurityOption1 = {
  sessionHeaderGramSession: string;
};

export type WithdrawWorkloadIssuerSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type WithdrawWorkloadIssuerSecurity = {
  option1?: WithdrawWorkloadIssuerSecurityOption1 | undefined;
  option2?: WithdrawWorkloadIssuerSecurityOption2 | undefined;
};

export type WithdrawWorkloadIssuerRequest = {
  /**
   * The workload issuer id.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type WithdrawWorkloadIssuerSecurityOption1$Outbound = {
  "session_header_Gram-Session": string;
};

/** @internal */
export const WithdrawWorkloadIssuerSecurityOption1$outboundSchema:
  z.ZodMiniType<
    WithdrawWorkloadIssuerSecurityOption1$Outbound,
    WithdrawWorkloadIssuerSecurityOption1
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function withdrawWorkloadIssuerSecurityOption1ToJSON(
  withdrawWorkloadIssuerSecurityOption1: WithdrawWorkloadIssuerSecurityOption1,
): string {
  return JSON.stringify(
    WithdrawWorkloadIssuerSecurityOption1$outboundSchema.parse(
      withdrawWorkloadIssuerSecurityOption1,
    ),
  );
}

/** @internal */
export type WithdrawWorkloadIssuerSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const WithdrawWorkloadIssuerSecurityOption2$outboundSchema:
  z.ZodMiniType<
    WithdrawWorkloadIssuerSecurityOption2$Outbound,
    WithdrawWorkloadIssuerSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function withdrawWorkloadIssuerSecurityOption2ToJSON(
  withdrawWorkloadIssuerSecurityOption2: WithdrawWorkloadIssuerSecurityOption2,
): string {
  return JSON.stringify(
    WithdrawWorkloadIssuerSecurityOption2$outboundSchema.parse(
      withdrawWorkloadIssuerSecurityOption2,
    ),
  );
}

/** @internal */
export type WithdrawWorkloadIssuerSecurity$Outbound = {
  Option1?: WithdrawWorkloadIssuerSecurityOption1$Outbound | undefined;
  Option2?: WithdrawWorkloadIssuerSecurityOption2$Outbound | undefined;
};

/** @internal */
export const WithdrawWorkloadIssuerSecurity$outboundSchema: z.ZodMiniType<
  WithdrawWorkloadIssuerSecurity$Outbound,
  WithdrawWorkloadIssuerSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => WithdrawWorkloadIssuerSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => WithdrawWorkloadIssuerSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function withdrawWorkloadIssuerSecurityToJSON(
  withdrawWorkloadIssuerSecurity: WithdrawWorkloadIssuerSecurity,
): string {
  return JSON.stringify(
    WithdrawWorkloadIssuerSecurity$outboundSchema.parse(
      withdrawWorkloadIssuerSecurity,
    ),
  );
}

/** @internal */
export type WithdrawWorkloadIssuerRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const WithdrawWorkloadIssuerRequest$outboundSchema: z.ZodMiniType<
  WithdrawWorkloadIssuerRequest$Outbound,
  WithdrawWorkloadIssuerRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function withdrawWorkloadIssuerRequestToJSON(
  withdrawWorkloadIssuerRequest: WithdrawWorkloadIssuerRequest,
): string {
  return JSON.stringify(
    WithdrawWorkloadIssuerRequest$outboundSchema.parse(
      withdrawWorkloadIssuerRequest,
    ),
  );
}
